import { Box } from '@mui/material';
import AssistantImage from '@public/images/assistant/myta/assistant.jpg';
import { useStyles } from './styles';

export const VirtualAssistantIcon = ({
  isLargeButton,
}: {
  isLargeButton?: boolean;
}) => {
  const classes = useStyles(isLargeButton);

  return (
    <Box sx={classes.iconContainer} className="virtual-assistant-icon">
      <img style={classes.icon} src={AssistantImage} />
    </Box>
  );
};
